// Frontend\src\component\demodashboard\flowdesigners\nodes\GeminiModelNode.jsx
import { Handle, Position } from "reactflow";

export default function GeminiModelNode({ selected, data }) {
  const status = data?.status || "idle";
  const isSelected = selected === true;

  const isVisuallyRunning = status === "running" || isSelected;

  const baseStyles = {
    idle: { borderColor: "#ccc", boxShadow: "none" },
    running: { borderColor: "#f97316", boxShadow: "0 0 20px rgba(249, 115, 22, 0.8)" },
    done: { borderColor: "#22c55e", boxShadow: "0 0 14px rgba(34, 197, 94, 0.5)" },
  };

  const currentStyle = status === "done"
    ? baseStyles.done
    : isVisuallyRunning
      ? baseStyles.running
      : baseStyles.idle;

  return (
    <div
      style={{
        padding: 12,
        borderRadius: 8,
        background: "#fff",
        border: isSelected ? "4px solid #2563eb" : `3px solid ${currentStyle.borderColor}`,
        boxShadow: isSelected
          ? `0 0 0 5px rgba(37, 99, 235, 0.3), ${currentStyle.boxShadow}`
          : currentStyle.boxShadow,
        transition: "all 0.4s ease",
        position: "relative",
      }}
    >
      <Handle type="target" position={Position.Left} />

      <div style={{ textAlign: "center" }}>
        <strong>Gemini AI</strong>
      </div>
    </div>
  );
}